<form [formGroup]="richEditorForm">
  <div class="form-group">
    <label class="sb_label">{{ labelName }}</label>
    <ckeditor
      [editor]="Editor"
      [config]="config"
      formControlName="data"
      id="editor"
      (ready)="onReady($event)"
      [ngStyle]="{ 'min-height': editorHeight, 'max-height': editorHeight }"
      [ngClass]="{ 'editor-large': editorHeight }"
    ></ckeditor>
  </div>
</form>
